<template>
  <div class="overallcontainer" oncontextmenu="return false">


    <router-view/>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: "app",
  created() {
    $(window).on('keydown',function(event){
      if(event.keyCode==123){
        return false;
      }else if(event.ctrlKey && event.shiftKey && event.keyCode==73){
        return false;
      }else if(event.ctrlKey && event.keyCode==73){
        return false;
      }
    });
  }
};
</script>
<style>
body {
  background-color: #F0F2F5 !important;
}
</style>
